export default "__VITE_ASSET__CAw887Nv__"